import React, { useState, useRef, useMemo } from "react";
import { observer } from "mobx-react";
import { Autocomplete, Select, Button } from "@ann/web-components";
import { 
  FiltersContainer,
  SearchContainer 
} from "./Filters.styled";

const Filters = observer(() => {
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState(0);
  const [searchTermCategory, setSearchTermCategory] = useState("");
  const [searchTermLastUpdate, setSearchTermLastUpdate] = useState("");
  const [filtersKey, setFiltersKey] = useState(0);
  const autocompleteRef = useRef(null);

  // Filter options
  const categoryOptions = [
    { label: "General", value: "general" },
    { label: "Customer Service", value: "customer_service" },
    { label: "Sales", value: "sales" },
    { label: "Support", value: "support" },
    { label: "Technical", value: "technical" },
    { label: "Billing", value: "billing" },
    { label: "Follow-up", value: "follow_up" },
    { label: "Internal", value: "internal" },
    { label: "Meeting Notes", value: "meeting_notes" },
    { label: "Action Items", value: "action_items" },
  ];

  const lastUpdateOptions = [
    { label: "Last 7 days", value: "last_7_days" },
    { label: "Last 30 days", value: "last_30_days" },
    { label: "This month", value: "this_month" },
    { label: "This year", value: "this_year" },
  ];

  // Filtered options based on search terms
  const filteredCategory = useMemo(() => {
    if (!searchTermCategory.trim()) return categoryOptions;
    const searchLower = searchTermCategory.toLowerCase();
    return categoryOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermCategory]);

  const filteredLastUpdate = useMemo(() => {
    if (!searchTermLastUpdate.trim()) return lastUpdateOptions;
    const searchLower = searchTermLastUpdate.toLowerCase();
    return lastUpdateOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermLastUpdate]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    // Here you can add your search logic or call a callback function
    // to update the parent component's state
  };

  const handleSearchClear = () => {
    setSearchValue("");
    setSearchKey((prev) => prev + 1);

    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const handleCategoryChange = (items) => {
    // Handle category filter changes
    console.log("Category filter changed:", items);
  };

  const handleLastUpdateChange = (items) => {
    // Handle last update filter changes
    console.log("Last update filter changed:", items);
  };

  const handleClearAllFilters = () => {
    setSearchValue("");
    setSearchTermCategory("");
    setSearchTermLastUpdate("");
    setSearchKey((prev) => prev + 1);
    setFiltersKey((prev) => prev + 1);
    
    // Clear autocomplete input
    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

  return (
    <FiltersContainer>
      <SearchContainer>
        <Autocomplete
          key={searchKey}
          ref={autocompleteRef}
          value={searchValue}
          onChange={handleSearchChange}
          onSearch={() => {}}
          onSuggestionSelect={() => {}}
          onClear={handleSearchClear}
          placeholder="Search notes..."
          suggestions={[
            "Customer meeting notes",
            "Follow-up reminder",
            "Support ticket notes",
            "Sales call summary",
            "Technical issue notes",
            "Billing discussion",
            "Action items",
            "Internal notes",
          ]}
        />
      </SearchContainer>
      <Select
        key={`category-filter-${filtersKey}`}
        label="Category"
        placeholder="Category"
        onChange={handleCategoryChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredCategory.map((category) => (
            <Select.Item
              key={category.value}
              value={category.value}
              label={category.label}
            >
              {category.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Select
        key={`last-update-filter-${filtersKey}`}
        label="Last Update"
        placeholder="Last Update"
        onChange={handleLastUpdateChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredLastUpdate.map((option) => (
            <Select.Item
              key={option.value}
              value={option.value}
              label={option.label}
            >
              {option.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Button
        icon=""
        iconLeft=""
        iconRight=""
        label="Clear Filters"
        size="medium"
        type="secondary"
        onClick={handleClearAllFilters}
      />
    </FiltersContainer>
  );
});

export default Filters; 